var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("div", {
    staticClass: "panelRow"
  }, [_c("div", [_vm._v(_vm._s(_vm.i18n["label"]) + "：")]), _c("el-input", {
    staticStyle: {
      width: "90%",
      "font-size": "12px"
    },
    attrs: {
      disabled: _vm.readOnly,
      value: _vm.model.label,
      placeholder: "请输入标题"
    },
    on: {
      input: function input(value) {
        _vm.onChange("label", value);
      }
    }
  })], 1), _c("div", {
    staticClass: "panelRow"
  }, [_c("el-checkbox", {
    attrs: {
      disabled: _vm.readOnly,
      value: !!_vm.model.hideIcon
    },
    on: {
      change: function change(value) {
        return _vm.onChange("hideIcon", value);
      }
    }
  }, [_vm._v(_vm._s(_vm.i18n["hideIcon"]))])], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };